// Blade Modal Functionality
document.addEventListener('DOMContentLoaded', function() {
    const modalTrigger = document.querySelector('[data-blade-modal-trigger]');
    const modalOverlay = document.querySelector('[data-blade-modal-overlay]');
    const modalClose = document.querySelector('[data-blade-modal-close]');
    const seeMoreButtons = document.querySelectorAll('[data-see-more]');
    const bladeTable = document.querySelector('.blade-table');
    const bladeRows = document.querySelectorAll('[data-blade-row]');
    
    if (!modalTrigger || !modalOverlay) return;
    
    // Function to move blade row to top
    function moveBladeRowToTop(row) {
        const tableBody = document.querySelector('[data-blade-table-body]');
        if (!tableBody || !row) return;
        
        const firstElement = tableBody.firstElementChild;
        tableBody.insertBefore(row, firstElement);
    }
    
    // Function to collapse all "View more" content in a row
    function collapseAllViewMoreContent(row) {
        // Collapse all text content "View more" buttons that are showing "View less"
        const textContainers = row.querySelectorAll('.blade-text-content-collapsible');
        textContainers.forEach(function(textContainer) {
            if (!textContainer.classList.contains('collapsed')) {
                // Get stored data
                const truncatedHTML = textContainer.getAttribute('data-truncated-html');
                const collapsedHeight = textContainer.getAttribute('data-collapsed-height');
                
                if (truncatedHTML && collapsedHeight) {
                    // Set current height first
                    const currentHeight = textContainer.offsetHeight;
                    textContainer.style.maxHeight = currentHeight + 'px';
                    
                    // Replace with truncated content
                    textContainer.innerHTML = truncatedHTML;
                    
                    // Collapse after a brief delay
                    setTimeout(function() {
                        textContainer.style.maxHeight = collapsedHeight + 'px';
                        textContainer.classList.add('collapsed');
                        
                        // Update button text
                        const viewMoreButton = textContainer.parentElement.querySelector('.blade-text-view-more');
                        if (viewMoreButton) {
                            viewMoreButton.textContent = 'View more';
                        }
                    }, 10);
                }
            }
        });
        
        // Collapse collapsed view equivalent items
        const collapsedBladeList = row.querySelector('.blade-body-list-equivalent');
        if (collapsedBladeList && !collapsedBladeList.classList.contains('collapsed')) {
            const collapsedViewButton = row.querySelector('[data-see-more][data-collapsed-view]');
            if (collapsedViewButton) {
                const collapsedItems = 4;
                let totalHeight = 0;
                for (let i = 0; i < Math.min(collapsedItems, collapsedBladeList.children.length); i++) {
                    const child = collapsedBladeList.children[i];
                    const style = window.getComputedStyle(child);
                    const marginTop = parseFloat(style.marginTop);
                    const marginBottom = parseFloat(style.marginBottom);
                    totalHeight += child.offsetHeight + marginTop + marginBottom;
                }
                
                const currentHeight = collapsedBladeList.offsetHeight;
                collapsedBladeList.style.maxHeight = currentHeight + 'px';
                
                setTimeout(function() {
                    collapsedBladeList.style.maxHeight = totalHeight + 'px';
                    collapsedBladeList.classList.add('collapsed');
                    collapsedViewButton.textContent = 'View more';
                }, 10);
            }
        }
        
        // Collapse expanded view equivalent items
        // Only collapse if the row is currently expanded (visible), otherwise just reset state
        const isRowExpanded = row.classList.contains('blade-row-expanded');
        const expandedBladeList = row.querySelector('.blade-body-list-equivalent-expanded');
        const expandedViewButton = row.querySelector('[data-see-more-expanded]');
        
        if (expandedBladeList) {
            if (isRowExpanded && !expandedBladeList.classList.contains('collapsed')) {
                // Row is expanded and list is expanded - collapse it properly
                if (expandedViewButton) {
                    const collapsedItems = 3;
                    let totalHeight = 0;
                    
                    for (let i = 0; i < Math.min(collapsedItems, expandedBladeList.children.length); i++) {
                        const child = expandedBladeList.children[i];
                        if (child) {
                            const style = window.getComputedStyle(child);
                            const marginTop = parseFloat(style.marginTop) || 0;
                            const marginBottom = parseFloat(style.marginBottom) || 0;
                            totalHeight += child.offsetHeight + marginTop + marginBottom;
                        }
                    }
                    
                    if (totalHeight > 0) {
                        const currentHeight = expandedBladeList.offsetHeight;
                        expandedBladeList.style.maxHeight = currentHeight + 'px';
                        
                        setTimeout(function() {
                            expandedBladeList.style.maxHeight = totalHeight + 'px';
                            expandedBladeList.classList.add('collapsed');
                            expandedViewButton.textContent = 'View more';
                        }, 10);
                    }
                }
            } else if (!isRowExpanded) {
                // Row is collapsed - just ensure the list is in collapsed state for when it expands again
                // Don't try to calculate heights since content is hidden
                const collapsedItems = 3;
                if (expandedBladeList.children.length > collapsedItems) {
                    // Reset to collapsed state
                    expandedBladeList.classList.add('collapsed');
                    if (expandedViewButton) {
                        expandedViewButton.textContent = 'View more';
                        // Reset maxHeight to let CSS handle it
                        expandedBladeList.style.maxHeight = '';
                    }
                } else {
                    // 3 or fewer items - remove collapsed class so all show
                    expandedBladeList.classList.remove('collapsed');
                    expandedBladeList.style.maxHeight = '';
                }
            }
        }
    }
    
    // Function to expand a blade row
    function expandBladeRow(row, skipScroll) {
        // Default skipScroll to false if not provided
        skipScroll = skipScroll || false;
        
        // Collapse all "View more" content in other rows first
        bladeRows.forEach(function(otherRow) {
            if (otherRow !== row) {
                // Collapse the row visually
                otherRow.classList.remove('blade-row-expanded');
                otherRow.classList.add('blade-row-collapsed');
                
                // Collapse all "View more" content in this row
                collapseAllViewMoreContent(otherRow);
            }
        });
        
        // Expand selected row - use requestAnimationFrame for smooth transition
        requestAnimationFrame(function() {
            row.classList.remove('blade-row-collapsed');
            row.classList.add('blade-row-expanded');
            
            // Trigger reflow to ensure display change is applied before transitions
            void row.offsetHeight;
            
            // Initialize equivalent names in expanded view after row becomes visible
            setTimeout(function() {
                const expandedEquivalentList = row.querySelector('.blade-body-list-equivalent-expanded');
                if (expandedEquivalentList && expandedEquivalentList.children.length > 0) {
                    const collapsedItems = 3;
                    
                    // If it has the collapsed class, ensure proper height is set
                    if (expandedEquivalentList.classList.contains('collapsed')) {
                        let totalHeight = 0;
                        for (let i = 0; i < Math.min(collapsedItems, expandedEquivalentList.children.length); i++) {
                            const child = expandedEquivalentList.children[i];
                            if (child) {
                                const style = window.getComputedStyle(child);
                                const marginTop = parseFloat(style.marginTop) || 0;
                                const marginBottom = parseFloat(style.marginBottom) || 0;
                                totalHeight += child.offsetHeight + marginTop + marginBottom;
                            }
                        }
                        if (totalHeight > 0) {
                            expandedEquivalentList.style.maxHeight = totalHeight + 'px';
                        }
                    } else if (expandedEquivalentList.children.length <= collapsedItems) {
                        // Show all items if 3 or fewer
                        expandedEquivalentList.style.maxHeight = expandedEquivalentList.scrollHeight + 'px';
                    }
                }
            }, 100);
            
            // Initialize text truncation for expanded content
            setTimeout(function() {
                initializeTextContentTruncation();
            }, 150);
            
            // Scroll to snap to the top of the expanded row with offset
            // Skip scrolling if skipScroll is true (initial modal open)
            if (!skipScroll) {
                setTimeout(function() {
                    const scrollContainer = document.querySelector('.blade-modal-wrapper');
                    if (scrollContainer) {
                        // Get the row's position relative to the scroll container
                        const containerRect = scrollContainer.getBoundingClientRect();
                        const rowRect = row.getBoundingClientRect();
                        const currentScrollTop = scrollContainer.scrollTop;
                        
                        // Calculate the row's position relative to the container
                        const rowTopRelative = rowRect.top - containerRect.top + currentScrollTop;
                        
                        // Add offset from top (1.5rem = 24px)
                        const offsetTop = 24; // 1.5rem
                        
                        scrollContainer.scrollTo({
                            top: Math.max(0, rowTopRelative - offsetTop),
                            behavior: 'smooth'
                        });
                    } else {
                        // Fallback: scroll the row into view at the top
                        row.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 100);
            }
        });
    }
    
    // Function to collapse a blade row (skipScroll = true when closing modal to avoid scroll + reflow work)
    function collapseBladeRow(row, skipScroll) {
        skipScroll = skipScroll || false;
        row.classList.remove('blade-row-expanded');
        row.classList.add('blade-row-collapsed');
        
        // Reset all text content to truncated state
        const textContainers = row.querySelectorAll('.blade-text-content-collapsible');
        textContainers.forEach(function(textContainer) {
            const truncatedHTML = textContainer.getAttribute('data-truncated-html');
            const collapsedHeight = textContainer.getAttribute('data-collapsed-height');
            
            if (truncatedHTML && collapsedHeight) {
                if (skipScroll) {
                    // Instant collapse when closing modal (no reflow from offsetHeight, no setTimeout)
                    textContainer.style.maxHeight = collapsedHeight + 'px';
                    textContainer.innerHTML = truncatedHTML;
                    textContainer.classList.add('collapsed');
                    var viewMoreButton = textContainer.parentElement.querySelector('.blade-text-view-more');
                    if (viewMoreButton) viewMoreButton.textContent = 'View more';
                } else {
                    // Animated collapse when modal stays open
                    var currentHeight = textContainer.offsetHeight;
                    textContainer.style.maxHeight = currentHeight + 'px';
                    textContainer.innerHTML = truncatedHTML;
                    setTimeout(function() {
                        textContainer.style.maxHeight = collapsedHeight + 'px';
                        textContainer.classList.add('collapsed');
                        var btn = textContainer.parentElement.querySelector('.blade-text-view-more');
                        if (btn) btn.textContent = 'View more';
                    }, 10);
                }
            } else {
                textContainer.removeAttribute('data-initialized');
            }
        });
        
        if (!skipScroll) {
            setTimeout(function() {
                var collapsedViewContainers = row.querySelectorAll('.blade-collapsed-content-section .blade-text-content-collapsible:not([data-initialized])');
                if (collapsedViewContainers.length > 0) {
                    initializeTextContentTruncation();
                }
            }, 150);
        }
        
        if (!skipScroll) {
            setTimeout(function() {
                var scrollContainer = document.querySelector('.blade-modal-wrapper');
                if (scrollContainer) {
                    var containerRect = scrollContainer.getBoundingClientRect();
                    var rowRect = row.getBoundingClientRect();
                    var currentScrollTop = scrollContainer.scrollTop;
                    var rowTopRelative = rowRect.top - containerRect.top + currentScrollTop;
                    var rowHeight = row.offsetHeight;
                    var rowBottomRelative = rowTopRelative + rowHeight;
                    scrollContainer.scrollTo({
                        top: rowBottomRelative - scrollContainer.clientHeight,
                        behavior: 'smooth'
                    });
                } else {
                    row.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            }, 200);
        }
    }
    
    // Handle tile clicks
    bladeRows.forEach(function(row) {
        row.addEventListener('click', function(e) {
            // Don't trigger if clicking on links, buttons, or collapse button
            // View more buttons handle expansion themselves via their own handlers
            // Learn more links should navigate without expanding the row
            if (e.target.closest('a') || e.target.closest('button') || e.target.closest('.blade-collapse-button')) {
                return;
            }
            
            // Always expand the clicked row (don't collapse if already expanded)
            expandBladeRow(row);
        });
    });
    
    // Explicitly prevent Learn more links from expanding rows
    if (modalOverlay) {
        modalOverlay.addEventListener('click', function(e) {
            const learnMoreLink = e.target.closest('.blade-learn-more-link');
            if (learnMoreLink) {
                e.stopPropagation();
                // Allow default link behavior (navigation)
            }
        });
    }
    
    // Handle mobile "Click to Expand" button clicks
    if (modalOverlay) {
        modalOverlay.addEventListener('click', function(e) {
            const expandMobileButton = e.target.closest('[data-blade-expand-mobile]');
            if (expandMobileButton) {
                e.preventDefault();
                e.stopPropagation();
                const row = expandMobileButton.closest('.blade-row');
                if (row) {
                    expandBladeRow(row);
                }
            }
        });
    }
    
    // Handle collapse button clicks using event delegation
    if (modalOverlay) {
        modalOverlay.addEventListener('click', function(e) {
            const collapseButton = e.target.closest('[data-blade-collapse]');
            if (collapseButton) {
                e.preventDefault();
                e.stopPropagation();
                const row = collapseButton.closest('.blade-row');
                if (row) {
                    collapseBladeRow(row);
                }
            }
        });
    }
    
    function normalizeForBladeMatch(str) {
        if (!str || typeof str !== 'string') return '';
        return str.trim()
            .replace(/\s*\(\s*/g, ' ')
            .replace(/\s*\)\s*/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function getSelectedCurveValueFromForm() {
        var form = document.querySelector('.variant-picker__form');
        if (!form) return null;
        var fieldsets = form.querySelectorAll('fieldset');
        for (var f = 0; f < fieldsets.length; f++) {
            var legend = fieldsets[f].querySelector('legend');
            var legendText = legend ? (legend.textContent || '').trim() : '';
            if (legendText !== 'Curve') continue;
            var checked = fieldsets[f].querySelector('input[type="radio"]:checked');
            if (checked && checked.value) return checked.value;
            return null;
        }
        return null;
    }

    function matchBladeRowByTitle(variantNorm) {
        if (!variantNorm) return null;
        var matchingRows = [];
        for (var r = 0; r < bladeRows.length; r++) {
            var row = bladeRows[r];
            var bladeTitle = row.getAttribute('data-blade-title');
            if (!bladeTitle) continue;
            var bladeNorm = normalizeForBladeMatch(bladeTitle);
            if (!bladeNorm) continue;
            var matched = variantNorm.indexOf(bladeNorm) !== -1 || bladeNorm.indexOf(variantNorm) !== -1;
            if (matched) {
                var isExactMatch = variantNorm === bladeNorm;
                var wordBoundaryRegex;
                try {
                    wordBoundaryRegex = new RegExp('\\b' + bladeNorm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i');
                } catch (err) {
                    wordBoundaryRegex = /./;
                }
                var isWordBoundaryMatch = wordBoundaryRegex.test(variantNorm);
                matchingRows.push({
                    row: row,
                    bladeTitle: bladeTitle,
                    length: bladeNorm.length,
                    isExactMatch: isExactMatch,
                    isWordBoundaryMatch: isWordBoundaryMatch
                });
            }
        }
        matchingRows.sort(function(a, b) {
            if (a.isExactMatch !== b.isExactMatch) return b.isExactMatch - a.isExactMatch;
            if (a.isWordBoundaryMatch !== b.isWordBoundaryMatch) return b.isWordBoundaryMatch - a.isWordBoundaryMatch;
            return b.length - a.length;
        });
        return matchingRows.length > 0 ? matchingRows[0].row : null;
    }

    function getSelectedBladeRow() {
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');

        if (!variantId) {
            var variantInput = document.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
                variantId = variantInput.value;
            }
        }

        var variantNorm = null;
        if (variantId) {
            var variantsScript = document.querySelector('[data-name="product-variants"]');
            if (variantsScript) {
                var variants;
                try {
                    variants = JSON.parse(variantsScript.textContent);
                } catch (e) {
                    console.error('[BladeModal] Failed to parse product variants:', e);
                }
                if (variants) {
                    var selectedVariant = variants.find(function(v) { return v.id.toString() === String(variantId); });
                    if (selectedVariant) {
                        variantNorm = normalizeForBladeMatch(selectedVariant.title);
                    }
                }
            }
        }

        if (!variantNorm) {
            var curveValue = getSelectedCurveValueFromForm();
            if (curveValue) {
                variantNorm = normalizeForBladeMatch(curveValue);
            }
        }

        if (!variantNorm) {
            return null;
        }

        return matchBladeRowByTitle(variantNorm);
    }
    
    // Open modal and expand selected blade
    modalTrigger.addEventListener('click', function(e) {
        e.preventDefault();

        if (window.highlightSelectedBladeRow) {
            window.highlightSelectedBladeRow();
        }

        var selectedRow = getSelectedBladeRow();
        if (selectedRow) {
            moveBladeRowToTop(selectedRow);
            expandBladeRow(selectedRow, true);
        }

        modalOverlay.classList.add('active');
        document.body.classList.add('blade-modal-open');
        
        // Scroll to the top so the selected (and now first) row is visible
        setTimeout(function() {
            var scrollContainer = document.querySelector('.blade-modal-wrapper');
            if (scrollContainer) {
                scrollContainer.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }, 100);
    });
    
    // Close modal: hide immediately so click handler returns fast, then collapse rows off the main thread
    function closeModal() {
        modalOverlay.classList.remove('active');
        document.body.classList.remove('blade-modal-open');
        // Defer collapse work to avoid long click handler and forced reflows
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                bladeRows.forEach(function(row) {
                    collapseBladeRow(row, true);
                });
            });
        });
    }
    
    // Close on close button click
    if (modalClose) {
        modalClose.addEventListener('click', closeModal);
    }
    
    // Close on overlay click
    modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
            closeModal();
        }
    });
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
            closeModal();
        }
    });
    
   // See More functionality for collapsed view (3 items)
   const collapsedViewButtons = document.querySelectorAll('[data-see-more][data-collapsed-view]');
   collapsedViewButtons.forEach(function(button) {
       button.addEventListener('click', function(e) {
           e.preventDefault();
           // Don't stop propagation - allow row to expand when clicking View more
           const bladeRow = button.closest('.blade-row');
           const bladeList = bladeRow.querySelector('.blade-body-list-equivalent');
           const isCollapsedState = bladeRow && bladeRow.classList.contains('blade-row-collapsed');

           // Number of items to show when collapsed
           const collapsedItems = 4;

           if (bladeList.classList.contains('collapsed')) {
               // Expand the row first when clicking View more (if in collapsed state)
               if (isCollapsedState) {
                   expandBladeRow(bladeRow);
                   
                   // Find the corresponding expanded equivalent list and trigger its View more
                   setTimeout(function() {
                       const expandedContent = bladeRow.querySelector('.blade-expanded-content');
                       if (expandedContent) {
                           const expandedEquivalentSection = expandedContent.querySelector('.blade-equivalent-section');
                           if (expandedEquivalentSection) {
                               const expandedBladeList = expandedEquivalentSection.querySelector('.blade-body-list-equivalent-expanded');
                               const expandedViewMoreButton = expandedEquivalentSection.querySelector('[data-see-more-expanded]');
                               
                               if (expandedBladeList && expandedViewMoreButton && expandedBladeList.classList.contains('collapsed')) {
                                   // Trigger click on expanded View more button
                                   expandedViewMoreButton.click();
                               }
                           }
                       }
                   }, 200);
               }
               
               // Expand: show all items
               bladeList.style.maxHeight = bladeList.scrollHeight + 'px';
               button.textContent = 'View less';
               bladeList.classList.remove('collapsed');
           } else {
               // Collapse: calculate height of first N items dynamically
               let totalHeight = 0;
               for (let i = 0; i < Math.min(collapsedItems, bladeList.children.length); i++) {
                   const child = bladeList.children[i];
                   const style = window.getComputedStyle(child);
                   const marginTop = parseFloat(style.marginTop);
                   const marginBottom = parseFloat(style.marginBottom);
                   totalHeight += child.offsetHeight + marginTop + marginBottom;
               }

               bladeList.style.maxHeight = totalHeight + 'px';
               button.textContent = 'View more';
               bladeList.classList.add('collapsed');
           }
       });
   });
   
   // See More functionality for expanded view (6 items)
   const expandedViewButtons = document.querySelectorAll('[data-see-more-expanded]');
   expandedViewButtons.forEach(function(button) {
       button.addEventListener('click', function(e) {
           e.preventDefault();
           // Don't stop propagation - allow row to expand when clicking View more
           const bladeRow = button.closest('.blade-row');
           const bladeList = bladeRow.querySelector('.blade-body-list-equivalent-expanded');

           // Number of items to show when collapsed (expanded state)
           const collapsedItems = 3;

           if (bladeList.classList.contains('collapsed')) {
               // Expand: show all items
               bladeList.style.maxHeight = bladeList.scrollHeight + 'px';
               button.textContent = 'View less';
               bladeList.classList.remove('collapsed');
           } else {
               // Collapse: calculate height of first N items dynamically
               let totalHeight = 0;
               for (let i = 0; i < Math.min(collapsedItems, bladeList.children.length); i++) {
                   const child = bladeList.children[i];
                   const style = window.getComputedStyle(child);
                   const marginTop = parseFloat(style.marginTop);
                   const marginBottom = parseFloat(style.marginBottom);
                   totalHeight += child.offsetHeight + marginTop + marginBottom;
               }

               bladeList.style.maxHeight = totalHeight + 'px';
               button.textContent = 'View more';
               bladeList.classList.add('collapsed');
           }
           
           // Ensure row stays expanded when clicking View more
           expandBladeRow(bladeRow);
       });
   });
   
   // View More functionality for text content (descriptive, what it's good for, who uses it)
   // Process one container per frame to avoid long handler + forced reflow violations
   function processOneTextTruncation(textContainer) {
           if (textContainer.hasAttribute('data-initialized')) return;
           var wordLimit = parseInt(textContainer.getAttribute('data-word-limit'), 10) || 60;
           const viewMoreButton = textContainer.nextElementSibling;
           
           if (!viewMoreButton || !viewMoreButton.classList.contains('blade-text-view-more')) {
               return;
           }
           
           // Get text content (strip HTML tags for word counting)
           const fullHTML = textContainer.innerHTML;
           const tempDiv = document.createElement('div');
           tempDiv.innerHTML = fullHTML;
           const fullText = tempDiv.textContent || tempDiv.innerText || '';
           const words = fullText.trim().split(/\s+/).filter(word => word.length > 0);
           
           // Only show "View more" if content exceeds word limit
           if (words.length > wordLimit) {
               // Mark as initialized
               textContainer.setAttribute('data-initialized', 'true');
               
               // Create truncated version for height calculation
               const walker = document.createTreeWalker(
                   tempDiv,
                   NodeFilter.SHOW_TEXT,
                   null,
                   false
               );
               
               let wordCount = 0;
               const clone = tempDiv.cloneNode(true);
               const cloneWalker = document.createTreeWalker(
                   clone,
                   NodeFilter.SHOW_TEXT,
                   null,
                   false
               );
               
               let cloneNode;
               while (cloneNode = cloneWalker.nextNode()) {
                   const nodeText = cloneNode.textContent;
                   const nodeWords = nodeText.trim().split(/\s+/).filter(word => word.length > 0);
                   
                   if (wordCount + nodeWords.length <= wordLimit) {
                       wordCount += nodeWords.length;
                   } else {
                       const remainingWords = wordLimit - wordCount;
                       if (remainingWords > 0) {
                           const truncatedWords = nodeWords.slice(0, remainingWords);
                           cloneNode.textContent = truncatedWords.join(' ') + '...';
                       }
                       // Remove all remaining text nodes
                       let nextNode;
                       while (nextNode = cloneWalker.nextNode()) {
                           nextNode.textContent = '';
                       }
                       break;
                   }
               }
               
               // Store truncated HTML for reference
               const truncatedHTML = clone.innerHTML;
               
               // Create a temporary element to measure collapsed height
               const tempMeasure = document.createElement('div');
               tempMeasure.style.cssText = window.getComputedStyle(textContainer).cssText;
               tempMeasure.style.position = 'absolute';
               tempMeasure.style.visibility = 'hidden';
               tempMeasure.style.height = 'auto';
               tempMeasure.style.maxHeight = 'none';
               tempMeasure.style.width = textContainer.offsetWidth + 'px';
               tempMeasure.innerHTML = truncatedHTML;
               document.body.appendChild(tempMeasure);
               
               const collapsedHeight = tempMeasure.offsetHeight;
               document.body.removeChild(tempMeasure);
               
               // Store data
               textContainer.setAttribute('data-collapsed-height', collapsedHeight);
               textContainer.setAttribute('data-full-html', fullHTML);
               textContainer.setAttribute('data-truncated-html', truncatedHTML);
               
               textContainer.innerHTML = truncatedHTML;
               textContainer.style.maxHeight = collapsedHeight + 'px';
               textContainer.classList.add('collapsed');
               viewMoreButton.style.display = 'block';
               viewMoreButton.textContent = 'View more';
               
               // Add click handler
               viewMoreButton.addEventListener('click', function(e) {
                   e.preventDefault();
                   // Don't stop propagation - allow row to expand when clicking View more
                   
                   const bladeRow = textContainer.closest('.blade-row');
                   const isCollapsedState = bladeRow && bladeRow.classList.contains('blade-row-collapsed');
                   
                   if (textContainer.classList.contains('collapsed')) {
                       // Expand the row first when clicking View more (if in collapsed state)
                       if (bladeRow && isCollapsedState) {
                           expandBladeRow(bladeRow);
                           
                           // Find the corresponding expanded text content and trigger its View more
                           setTimeout(function() {
                               const expandedContent = bladeRow.querySelector('.blade-expanded-content');
                               if (expandedContent) {
                                   // Find the matching section in expanded view
                                   const sectionItem = textContainer.closest('.blade-content-item');
                                   let matchingSection = null;
                                   
                                   // Check for descriptive, what-good, or who-uses sections
                                   if (sectionItem.classList.contains('blade-descriptive-section')) {
                                       matchingSection = expandedContent.querySelector('.blade-descriptive-section');
                                   } else if (sectionItem.classList.contains('blade-what-good-section')) {
                                       matchingSection = expandedContent.querySelector('.blade-what-good-section');
                                   } else if (sectionItem.classList.contains('blade-who-uses-section')) {
                                       matchingSection = expandedContent.querySelector('.blade-who-uses-section');
                                   }
                                   
                                   // If matching section found and has View more button, trigger it
                                   if (matchingSection) {
                                       const expandedTextContainer = matchingSection.querySelector('.blade-text-content-collapsible');
                                       const expandedViewMoreButton = matchingSection.querySelector('.blade-text-view-more');
                                       
                                       if (expandedTextContainer && expandedViewMoreButton && expandedTextContainer.classList.contains('collapsed')) {
                                           // Trigger click on expanded View more button
                                           expandedViewMoreButton.click();
                                       }
                                   }
                               }
                           }, 200);
                       }
                       
                       // Expand: first set max-height to current height, then change content, then expand
                       const currentHeight = textContainer.offsetHeight;
                       textContainer.style.maxHeight = currentHeight + 'px';
                       
                       // Restore full content
                       textContainer.innerHTML = fullHTML;
                       
                       // Use requestAnimationFrame to ensure DOM is updated before measuring and expanding
                       requestAnimationFrame(function() {
                           const fullHeight = textContainer.scrollHeight;
                           textContainer.style.maxHeight = fullHeight + 'px';
                           textContainer.classList.remove('collapsed');
                           viewMoreButton.textContent = 'View less';
                       });
                   } else {
                       // Collapse: first set max-height to current height, then change content, then collapse
                       const currentHeight = textContainer.offsetHeight;
                       textContainer.style.maxHeight = currentHeight + 'px';
                       
                       // Replace with truncated content
                       textContainer.innerHTML = truncatedHTML;
                       
                       // Use requestAnimationFrame to ensure DOM is updated before collapsing
                       requestAnimationFrame(function() {
                           textContainer.style.maxHeight = collapsedHeight + 'px';
                           textContainer.classList.add('collapsed');
                           viewMoreButton.textContent = 'View more';
                       });
                   }
               });
           }
   }

   function initializeTextContentTruncation() {
       var list = document.querySelectorAll('.blade-text-content-collapsible');
       var queue = [];
       for (var i = 0; i < list.length; i++) {
           if (!list[i].hasAttribute('data-initialized')) queue.push(list[i]);
       }
       if (queue.length === 0) return;
       function processNext() {
           if (queue.length === 0) return;
           processOneTextTruncation(queue.shift());
           if (queue.length > 0) requestAnimationFrame(processNext);
       }
       requestAnimationFrame(processNext);
   }
   
   modalTrigger.addEventListener('click', function() {
       setTimeout(function() {
           initializeTextContentTruncation();
       }, 200);
   });
   
   // Also initialize when rows expand
   bladeRows.forEach(function(row) {
       const observer = new MutationObserver(function(mutations) {
           if (row.classList.contains('blade-row-expanded')) {
               setTimeout(initializeTextContentTruncation, 100);
           }
       });
       
       observer.observe(row, {
           attributes: true,
           attributeFilter: ['class']
       });
   });
   
   // Also initialize on page load if modal is already open
   if (modalOverlay && modalOverlay.classList.contains('active')) {
       setTimeout(initializeTextContentTruncation, 200);
   }

    // Custom scrollbar for iOS compatibility
    const scrollContainer = document.getElementById('blade-body-scroll');
    const scrollbarThumb = document.querySelector('.blade-scrollbar-thumb');
    const customScrollbar = document.querySelector('.blade-custom-scrollbar');
    
    if (scrollContainer && scrollbarThumb && customScrollbar) {
        function updateScrollbar() {
            const scrollWidth = scrollContainer.scrollWidth;
            const clientWidth = scrollContainer.clientWidth;
            const scrollLeft = scrollContainer.scrollLeft;
            
            // Calculate thumb width as a percentage of visible area
            const thumbWidthPercent = (clientWidth / scrollWidth) * 100;
            scrollbarThumb.style.width = thumbWidthPercent + '%';
            
            // Calculate thumb position
            const maxScrollLeft = scrollWidth - clientWidth;
            const scrollPercent = maxScrollLeft > 0 ? scrollLeft / maxScrollLeft : 0;
            const maxThumbTranslate = 100 / thumbWidthPercent * (100 - thumbWidthPercent);
            const thumbTranslate = scrollPercent * maxThumbTranslate;
            
            scrollbarThumb.style.transform = 'translateX(' + thumbTranslate + '%)';
        }
        
        // Update on scroll
        scrollContainer.addEventListener('scroll', updateScrollbar, { passive: true });
        
        // Update on window resize
        window.addEventListener('resize', updateScrollbar);
        
        // Initial update when modal opens
        modalTrigger.addEventListener('click', function() {
            setTimeout(updateScrollbar, 100);
        });
        
        // Make scrollbar draggable
        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;
        
        customScrollbar.addEventListener('mousedown', handleDragStart);
        customScrollbar.addEventListener('touchstart', handleDragStart, { passive: true });
        
        document.addEventListener('mousemove', handleDragMove);
        document.addEventListener('touchmove', handleDragMove, { passive: false });
        
        document.addEventListener('mouseup', handleDragEnd);
        document.addEventListener('touchend', handleDragEnd);
        
        function handleDragStart(e) {
            isDragging = true;
            const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
            startX = clientX;
            startScrollLeft = scrollContainer.scrollLeft;
            customScrollbar.style.cursor = 'grabbing';
        }
        
        function handleDragMove(e) {
            if (!isDragging) return;
            
            const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
            const deltaX = clientX - startX;
            
            const scrollbarWidth = customScrollbar.offsetWidth;
            const thumbWidth = scrollbarThumb.offsetWidth;
            const scrollWidth = scrollContainer.scrollWidth;
            const clientWidth = scrollContainer.clientWidth;
            
            // Calculate scroll ratio
            const scrollRatio = (scrollWidth - clientWidth) / (scrollbarWidth - thumbWidth);
            scrollContainer.scrollLeft = startScrollLeft + (deltaX * scrollRatio);
            
            if (e.type === 'touchmove') {
                e.preventDefault();
            }
        }
        
        function handleDragEnd() {
            isDragging = false;
            customScrollbar.style.cursor = 'grab';
        }
    }
});